<header
  class="ade-header"
  [class.ade-header--search-open]="searchOpen"
  [class.ade-header--scrolled]="scrolled"
>
  <div
    class="ade-header__inner max-w-[1280px] mx-auto px-5 lg:px-12 h-full flex relative items-center justify-between lg:justify-between"
  >
    <!-- Logo -->
    <div class="flex items-center flex-shrink-0">
      <a
        [routerLink]="['/', activeLang]"
        class="flex items-center gap-2 cursor-pointer"
      >
        <img
          [src]="logoUrl"
          alt="Auto D'Época"
          class="ade-header__logo-image object-contain transition-all duration-300"
        />
      </a>
    </div>

    <!-- Acções mobile: pesquisa + hamburger -->
    <div class="lg:hidden flex items-center gap-2 ml-auto">
      <button
        class="ade-header__icon-btn"
        type="button"
        (click)="toggleSearch()"
        [attr.aria-label]="'Search' | transloco"
      >
        <mat-icon svgIcon="mat_outline:search" class="text-white"></mat-icon>
      </button>
      <button
        class="ade-header__icon-btn--mobile"
        type="button"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="'Toggle menu' | transloco"
      >
        <mat-icon
          [svgIcon]="mobileMenuOpen ? 'mat_outline:close' : 'mat_outline:menu'"
          class="text-white"
        ></mat-icon>
      </button>
    </div>

    <!-- Nav centrado absoluto -->
    <nav
      class="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2 w-full max-w-[600px] justify-center"
      *ngIf="navigation?.site"
    >
      <ng-container *ngFor="let item of navigation.site">
        <a
          *ngIf="item.type === 'basic'"
          [routerLink]="[item.link]"
          routerLinkActive="ade-header__nav-link--active"
          class="ade-header__nav-link uppercase tracking-wider transition-colors"
          >{{ item.title | transloco }}</a
        >

        <div *ngIf="item.type === 'group'" class="ade-header__nav-group">
          <button
            class="ade-header__nav-link uppercase tracking-wider"
            type="button"
          >
            {{ item.title | transloco }}
            <mat-icon
              class="ade-header__nav-arrow"
              svgIcon="mat_outline:keyboard_arrow_down"
            ></mat-icon>
          </button>
          <div class="ade-header__nav-dropdown">
            <a
              *ngFor="let child of item.children"
              [routerLink]="[child.link]"
              class="ade-header__nav-dropdown-item"
              >{{ child.title | transloco }}</a
            >
          </div>
        </div>
      </ng-container>
    </nav>

    <!-- Acções direita (desktop) -->
    <div class="hidden lg:flex items-center gap-6 ml-auto">
      <div class="flex items-center gap-4">
        <div class="relative flex items-center">
          <div
            class="flex items-center transition-all duration-300 overflow-hidden"
            [class.w-0]="!searchOpen"
            [class.opacity-0]="!searchOpen"
            [class.w-48]="searchOpen"
            [class.opacity-100]="searchOpen"
          >
            <input
              *ngIf="searchOpen"
              class="ade-header__search-input"
              type="text"
              [(ngModel)]="searchQuery"
              [placeholder]="'Pesquisar...' | transloco"
              autofocus
              (keydown.enter)="submitSearch()"
            />
          </div>
          <button
            class="ade-header__icon-btn"
            type="button"
            (click)="toggleSearch()"
            [attr.aria-label]="'Search' | transloco"
          >
            <mat-icon
              svgIcon="mat_outline:search"
              class="text-white"
            ></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile search -->
  <div class="ade-header__mobile-search lg:hidden" *ngIf="searchOpen">
    <input
      class="ade-header__search-input"
      type="text"
      [(ngModel)]="searchQuery"
      [placeholder]="'Pesquisar...' | transloco"
      autofocus
      (keydown.enter)="submitSearch()"
    />
  </div>

  <!-- Mobile nav -->
  <div
    class="ade-header__mobile-nav"
    *ngIf="mobileMenuOpen && navigation?.site"
  >
    <ng-container *ngFor="let item of navigation.site">
      <a
        *ngIf="item.type === 'basic'"
        [routerLink]="[item.link]"
        routerLinkActive="ade-header__mobile-link--active"
        class="ade-header__mobile-link"
        (click)="closeMobileMenu()"
        >{{ item.title | transloco }}</a
      >

      <div *ngIf="item.type === 'group'" class="ade-header__mobile-group">
        <div class="ade-header__mobile-label">{{ item.title | transloco }}</div>
        <a
          *ngFor="let child of item.children"
          [routerLink]="[child.link]"
          class="ade-header__mobile-sublink"
          (click)="closeMobileMenu()"
          >{{ child.title | transloco }}</a
        >
      </div>
    </ng-container>
  </div>
</header>
